import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Alert
} from "reactstrap";

const AddEditUserModal = ({
    isOpen,
    toggle,
    editingUser,
    setEditingUser,
    handleSave,
    isSaving,
    done,
    error
}) => {

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                {editingUser?.id ? "Edit User" : "Add User"}
            </ModalHeader>

            <ModalBody>
                {error && <Alert color="danger">{error}</Alert>}

                <Form>
                    <FormGroup>
                        <Label>Full Name</Label>
                        <Input
                            value={editingUser?.full_name || ""}
                            onChange={(e) =>
                                setEditingUser({ ...editingUser, full_name: e.target.value })
                            }
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label>Email</Label>
                        <Input
                            value={editingUser?.email || ""}
                            onChange={(e) =>
                                setEditingUser({ ...editingUser, email: e.target.value })
                            }
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label>Role</Label>
                        <Input
                            type="select"
                            value={editingUser?.role || "employee"}
                            disabled={editingUser && (editingUser?.role == "account_manager" || editingUser?.role == "admin") ? true : false}
                            onChange={(e) =>
                                setEditingUser({ ...editingUser, role: e.target.value })
                            }
                        >
                            <option value="admin">Admin</option>
                            <option value="account_manager">Account Manager</option>
                            <option value="location_manager">Location Manager</option>
                            <option value="employee">Employee</option>
                        </Input>
                    </FormGroup>

                    <FormGroup>
                        <Label>Password</Label>
                        <Input
                            value={editingUser?.shown_password || ""}
                            onChange={(e) =>
                                setEditingUser({ ...editingUser, shown_password: e.target.value })
                            }
                        />
                    </FormGroup>

                    <div className="text-end">
                        <Button color="success" onClick={handleSave} disabled={isSaving || done}>
                            {done ? "Done" : isSaving ? (
                                <span
                                    className="spinner-border spinner-border-sm me-1"
                                    role="status"
                                />
                            ) : (
                                "Save"
                            )}
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default AddEditUserModal;